import { getGeoLocation, getDeviceStatus } from '~/plugins/util/deviceUtils.js'

export const state = () => ({
  checkIn: {},
  checkOut: {},
})

export const actions = {
  async check(ctx, { type, payload }) {
    const url = type === 'in' ? '/check/checkIn' : '/check/checkOut'
    const [{ coords }, device] = await Promise.all([
      getGeoLocation(),
      getDeviceStatus(),
    ])
    return this.$axios.post(url, {
      ...payload,
      geolocation: {
        latitude: coords.latitude,
        longitude: coords.longitude,
      },
      check: {
        checkOutHour: device.clock,
        checkOutBattery: device.battery,
        checkOutNetwork: device.network,
      },
    })
  },
  async checkIn({ commit }, { params }) {
    const { data } = await this.$axios.post('check/checkIn', params)
  },
}

export const mutations = {
  setCheckIn(state, data) {
    state.checkIn = data
  },
  setCheckOut(state, data) {
    state.checkut = data
  },
}
